import { Navigate } from "react-router-dom";

const ReportV2 = () => {
    return <Navigate to="/reports/custom-reports" />;
};

export default ReportV2;
